import {
  type SanityProductOption,
  type SanityProductOptionSetting,
  type SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'
import { getDefaultOption, getVariantByDefaultOption } from './product'

/**
 * Gets default product variant for product.
 */
export const getDefaultVariantId = (
  productVariants?: SanityProductVariantFragment[],
  productOptions?: SanityProductOption[],
  productOptionSettings?: SanityProductOptionSetting[]
) => {
  if (typeof productOptions === 'undefined') {
    return null
  }

  const defaultOption = getDefaultOption(
    productOptions,
    productOptionSettings ?? []
  )
  const defaultVariant = getVariantByDefaultOption(
    productVariants ?? [],
    defaultOption
  )

  const firstVariant = productVariants?.[0]

  return defaultVariant?.variantID ?? firstVariant?.variantID ?? null
}
